import { useContext } from 'react'

import { ExtraFormContext } from '../components/Form'
import { InputProps } from '../interfaces'

export default function useInputOnAutoSubmit(props: InputProps): any {
  /**
   * Checks if this field should be able to auto-submit, based on the global
   * value in the extraCtx and on the local value passed into the input
   * props.
   */
  const { preventAutoSubmit } = props
  const extraCtx = useContext(ExtraFormContext)
  const { autoSubmitEnabled, onSubmit } = extraCtx || {}
  const canAutoSubmit = !preventAutoSubmit && !!autoSubmitEnabled
  return { canAutoSubmit, onSubmit }
}
